import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import { pymSendHeight } from "../utils/handlePym";
import DataContextProvider from "../context/DataContext";

const SUBTITLE_TEXT =
  "Click or tap the map below to find out how many days and afternoons the district judges in your county had no court proceedings, defined as “case events” by the Administrative Office of Pennsylvania Courts.";

const FOOTNOTE_TEXT = "";

class Main extends React.Component {
  componentDidMount() {
    // This is intended to fix bug where app is clipped at bottom
    // on initial load.
    pymSendHeight({ timeout: 500 });
    pymSendHeight({ timeout: 1000 });
  }

  componentDidUpdate() {
    // Because our app changes height based on displayed content, we
    // update the iframe height after DOM elements have been updated.
    pymSendHeight();
  }

  render() {
    const { data } = this.props;
    return (
      <div className="container__outer">
        <DataContextProvider data={data}>
          <div className="container__inner">
            <Header
              headline="Examining Pa. District Judges’ Calendars"
              subtitle={SUBTITLE_TEXT}
            />
            <Body />
            <Footer
              footnote={FOOTNOTE_TEXT}
              byline="Daniel Simmons Ritchie"
              source="Spotlight PA/PennLive.com analysis of MDJ schedules provided by Administrative Office of Pennsylvania Courts"
              outlet="Spotlight PA"
              outletUrl="https://www.spotlightpa.org/"
            />
          </div>
        </DataContextProvider>
      </div>
    );
  }
}

Main.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Main;
